import * as React from 'react'

import cn from 'classnames'
import { useRecoilValue } from 'recoil'

import { locale } from '../../../state/locale/atoms/locale'
import { Address } from '../../reusable/Address'
import { GoogleMaps } from '../../reusable/GoogleMaps'
import { ContactForm } from './components/ContactForm'
import styles from './Contact.module.scss'
import { IContactProps } from './Contact.types'

export const Contact = ({ data }: IContactProps) => {
  const lang = useRecoilValue(locale)

  return (
    <div className={styles.contactWrapper}>
      <div className={styles.column}>
        <h2 className={styles.companyName}>{data.name}</h2>
        {data.address.map((address) => (
          <Address address={address} key={address.id} />
        ))}
        <ContactForm />
      </div>

      <div className={cn(styles.column, styles.right)}>
        <GoogleMaps locale={lang} map={data.map} />
      </div>
    </div>
  )
}
